import { Component, OnInit, ViewChild, ElementRef, Inject, ChangeDetectorRef, Input, QueryList, EventEmitter, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {ErrorStateMatcher} from '@angular/material/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import { ProfileComponent, croppedimagedialog } from '../pages/profile/profile.component';
import { SocketService } from '../services/socket/socket.service';
import { PackComponent } from '../project/dashboard/pack/pack.component';


export interface Contacts {
	'@id': string;
	'@type': string;
	id: string;
	email: string;
  givenName: string;
  familyName: string;
	isProject: boolean;
	isAdmin: boolean;
	dateModified: string;
	user:any;
  invitation: boolean;
  value:string;
  color?:string;
}

@Component({
  selector: 'app-company-member',
  templateUrl: './company-member.component.html',
  styleUrls: ['./company-member.component.scss']
})
export class CompanyMemberComponent implements OnInit {

	contacts/*: Array<Contacts>*/ = [];
  searchContact: any;
	currentUser = null;
  confirm_mode = false;
  array_user_add = [];
  array_exised_user = [];
  admin = false;
  userEmail = '';
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;
  img: any;
  imageFil = null;
  @Output() groupQuit = new EventEmitter<any>();
  imgExists: boolean = true;
  vibrantColors = [
    "#FF5733", // Rouge vif
    "#FF8D1A", // Orange vif
    "#F9C74F", // Jaune doré
    "#4CAF50", // Vert
    "#D32F2F", // Rouge profond
    "#9C27B0", // Violet
    "#E91E63", // Rose
    "#FFEB3B", // Jaune
    "#00BCD4", // Bleu clair
    "#8BC34A", // Vert lime
    "#FF5722", // Orange foncé
    "#3F51B5", // Bleu indigo
    "#9E9D24", // Jaune-vert
    "#F44336", // Rouge éclatant
    "#00C853", // Vert vif
    "#9E1B32", // Rouge sombre
    "#F50057", // Rose fuchsia
    "#FF7043", // Orange corail
    "#8E24AA", // Violet intense
    "#388E3C"  // Vert forêt
  ];
  isEditingName = false;
  editedComName = '';


	constructor(private authService: AuthService, private socketService: SocketService, private router: Router,  public  dialog: MatDialog, private cd: ChangeDetectorRef) { 
  }

	ngOnInit() {
    this.confirm_mode = false;
		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.img = (this.currentUser.comImage ? this.getCompanyUrl(this.currentUser.comImage) : '../../assets/img/default-avatar.png');
    this.checkImageExists(this.img)
    //this.admin = this.currentUser.roles.includes('ROLE_MANAGER');
    this.admin = true;
    this.userEmail = this.currentUser.email;
    //this.currentUser.company = "bd5bcc26-9734-4e52-8074-01e827715298";
    if (this.currentUser.compId) {
      console.log("load contact")
		  this.loadContact();
    }
    this.authService.obUpdateCompany.subscribe((res) => {
      if(res){
        this.setCompanyImage(res);
      } 
    });

    this.authService.obUpdateCompname.subscribe((res) => {
      if(res){
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
          this.currentUser.comName = this.editedComName;
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      } 
    });
	}

  editName() {
    this.editedComName = this.currentUser.comName;
    this.isEditingName = true;
  }

  cancelEdit() {
    this.isEditingName = false;
    this.editedComName = this.currentUser.comName;
  }

  saveComName() {
    if (!this.editedComName || this.editedComName.trim() === '') {
      // Facultatif : Empêche la sauvegarde si le champ est vide
      return;
    }

    if (this.editedComName !== this.currentUser.comName) {
      var idcompany = JSON.parse(localStorage.getItem('currentUser')).compId;
      // Appel API ici pour sauvegarder le nom
      this.authService.updateCompanyName(this.editedComName).subscribe((response) => {
          this.currentUser.comName = this.editedComName;
          this.isEditingName = false;
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
          this.currentUser.comName = this.editedComName;
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          this.socketService.sendInstant({
              id: "0",
              action: "0",
              type: "UPDATECOMPNAME",
              author: this.currentUser.id,
              recipient: idcompany,
              text: "",
              copy: "",
              private: false,
              res: this.editedComName,
              project_lib: "",
              date: ""
            });
          // Affiche une notification de succès, etc.
        });
    } else {
      this.isEditingName = false;
    }
  }

  getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }

  getInitials(libelle: string): string {
    if(libelle){
      const words = libelle.split(' ');
      const getFirstChar = (word: string): string => {
        return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
      };
      const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

      return initials;
    }
  }

  checkImageExists(url: string): void {
    const img = new Image();
    img.crossOrigin = 'Anonymous';  // Si tu veux permettre CORS
    img.src = url;
  
    // Pour s'assurer de gérer toutes les erreurs
    img.onload = () => {
      this.imgExists = true;  // L'image se charge correctement
    };
  
    img.onerror = (error) => {
      this.imgExists = false;  // Si l'image ne se charge pas
      this.getCurrentCompany();
      /*
      //TO DO HEEEERE
      // Si c'est une erreur 404 (image non trouvée)
      if (error) {
      }*/
    };
  }

  getCurrentCompany(){
    var idcompany = JSON.parse(localStorage.getItem('currentUser')).compId;
     this.authService.getInfoCompany(idcompany)
     .subscribe( dataContact => {
        var logo  = dataContact['logo'];
        this.img = (logo ? this.getCompanyUrl(logo) : '../../assets/img/default-avatar.png');
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.currentUser.comImage = logo;
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
     }, (error) => {
     });
 
   }
  

   setCompanyImage(message = null){
    if(message){
      var logo  = message.res.logo;
      this.img = (logo ? this.getCompanyUrl(logo) : '../../assets/img/default-avatar.png');
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUser.comImage = logo;
      localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
    }
   }

  goBackChoice(){
    this.groupQuit.emit('param');
  }
  
  getUserBackground(contact){
      if(!contact || !contact.company) return;
      if(contact.roles.includes('ROLE_MANAGER') && contact.company.id === this.currentUser.compId){
        return "#f7f0d5";
      } else if(contact.company && contact.company.id === this.currentUser.compId){
        return "#e0eefa";
      } else return "#f7f0d5";
  }

	loadContact() {
		//this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
		this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
		  this.contacts = res['hydra:member'];
      this.contacts = this.contacts.sort(function (a, b) {
        if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) { return -1; }
        if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) { return 1; }
        return 0;
    })
      this.contacts.forEach(contact => {
        contact.color = this.getRandomColor();
      });
      this.loadContactNotRegister();
		},
	  	err => {
	      const error = err.error;
	      const errorS = error.message;
	      const errorD = error.detail;
	      const errorH = error['hydra:description'];
	      if (errorS === 'Bad credentials') {
	         alert(errorS);
	      } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
	        alert(errorD);
	      } else if (errorH) {
	        alert(errorH);
	      }
	    });
	}

  fileChangeEvent(event: any): void {
    const dialogRef = this.dialog.open(croppedimagedialog, {
      width: '700px',
      data: {event: event}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== null) {
        this.img = result.event;
        const reader = new FileReader();
        this.imageFil = result.fileToReturn;

        reader.readAsDataURL(this.imageFil);
          
        reader.onload = () => {
          this.cd.markForCheck();
        }; 
        if(this.imageFil) {
          this.authService.udapteCompanyImage(this.imageFil).subscribe( data => {
            this.socketService.sendInstant({
              id: "0",
              action: "0",
              type: "UPDATECOMPANY",
              author: this.currentUser.id,
              recipient: "",
              text: "",
              copy: "",
              private: false,
              res: data,
              project_lib: "",
              date: ""
            });
          }, (error) => {
              alert('une erreur est survenue');
          });
        
        }
      }
    });
  }

  showProfil(idUser): void{
    //this.dialog.closeAll();
    if(!idUser) return;
    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'contactpanel';
    /*
    dialogConfig.id = 'balchal718';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;*/
    dialogConfig.data = { idUser: idUser};
    //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProfileComponent, {
      //width: '350px',
      data: { idUser: idUser},
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });
    
    dialogRef.afterClosed().subscribe((result: any) => {
    });
    //dialogRef.close();
    
  }

  loadContactNotRegister() {
    this.authService.getCompagnyMemberNotRegister().subscribe(res => {
      var contact_not_resgiter = res['hydra:member'];
      for (var i = 0; i < contact_not_resgiter.length; i++) {
        var contactUser = <Contacts>contact_not_resgiter[i];
        contactUser.invitation = true;
        contactUser.value = contact_not_resgiter[i].value;
        contactUser.familyName = contact_not_resgiter[i].value;
        contactUser.familyName = contact_not_resgiter[i].value;
        contactUser.givenName = "";
        contactUser.color = this.getRandomColor();
        var contact = this.contacts.find(contact => contact.email === contactUser.value);
        if(!contact) this.contacts.push(contactUser);
        //this.contacts.push(contactUser);
      }
    },
      err => {
        const error = err.error;
        const errorS = error.message;
        const errorD = error.detail;
        const errorH = error['hydra:description'];
        if (errorS === 'Bad credentials') {
           alert(errorS);
        } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
          alert(errorD);
        } else if (errorH) {
          alert(errorH);
        }
      });
  }

	goToProfile(profilId) {
		this.router.navigate(['/profile/' + profilId]);
	}

	getAvatarlUrl(avatarLink) {
		return environment.server_url + avatarLink;
	}

  getCompanyUrl(avatarLink) {
		return environment.server_url+"/media/project_img/" + avatarLink;
	}

  deleteUserFromCompany(profilId) {
    this.authService.deleteUserCompany(profilId).subscribe(res => {
       this.loadContact();
    },
      err => {
        const error = err.error;
        const errorS = error.message;
        const errorD = error.detail;
        const errorH = error['hydra:description'];
        if (errorS === 'Bad credentials') {
           alert(errorS);
        } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
          alert(errorD);
        } else if (errorH) {
          alert(errorH);
        }
    });
  }

	fctAddMember() {
	    const dialogRef = this.dialog.open(addMemberCompany, {
	      panelClass: 'dashboarddialog-container',
	      data: {idcompany: this.currentUser['compId'], companyUser: this.contacts}
	    });

	    dialogRef.afterClosed().subscribe(result => {   
	    });
  }

  uploadFile(file) {

    this.authService.addMultipEmploye(file.item(0)).subscribe(
      res => {
        this.array_exised_user = res['user_existed'];
        this.array_user_add = res['user_invited'];
        this.confirm_mode = true;
        this.loadContact();
      },
      (error) => {
        if (error.status === 403) {
          this.openPackComponentDialog(1);
        } else if (error.status === 429) {
          this.openPackComponentDialog(3);
        } else if (error.status === 402) {
          const errorDescription = JSON.parse(error.error['hydra:description']);
          this.openPackComponentDialog(2, errorDescription.subscriptionPack);
        } else {
          alert('Erreur ! : ' + error);
          this.confirm_mode = false;
        }
      }
    );

    this.fileInput.nativeElement.value = '';

  }

  openPackComponentDialog(type = 0, currentPack = 'free'){
    const dialogRef = this.dialog.open(PackComponent, {
      panelClass: 'packclass',
      backdropClass: 'custom-backdrop-pack',
      height: "height: calc(-80px + 100vh);",
      data: { type: type, pack: currentPack}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  goToMembers(){
    this.confirm_mode = false;
  }


   
}


/////////////////// add contact view dialog ///////////////////

/* Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'addMemberCompany-dialog-dialog',
  templateUrl: './addMemberCompany-dialog.html',
  styleUrls: ['./addMemberCompany-dialog.scss']
})
export class addMemberCompany {
 
  contacts = [];
  // userStatus : { name: string }[];
  showNewContactInput = false;
  searchContact: any;
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  addingMember = false;
  @ViewChild('emailInput', {static: true}) emailInput: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<addMemberCompany>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
     private authService: AuthService) {

      /*this.authService.getContacts().subscribe( dataContact => {
        this.contacts = dataContact['hydra:member'];
      });*/
      
      	
      	this.contacts = [];
      	//this.loadContact();

      /*this.authService.getTheProject(this.data.project.replace("/api/projects/", ""))
      .subscribe(res => {
        var tmpArrayUser = res['userProject'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].user){
            this.projectUsers.push(tmpArrayUser[i]);
          }
        }

        let userStatus = []; 
        for (let index = 0; index < this.projectUsers.length; index++) {
          if(this.projectUsers[index]['user'])
          userStatus[this.projectUsers[index]['user']['id']] = this.projectUsers[index]['status'];
        }
        this.userStatus = userStatus;
      }, (error) => {
      });*/


      
  }


  loadContact(url?: string){
    url = url ? url : undefined;
    this.authService.getContacts(url).subscribe(res => {
      	this.contacts = this.contacts.concat(res['hydra:member']);
    	for (var i = 0; i < this.contacts.length; i++) {
    		for (let index = 0; index < this.data.companyUser.length; index++) {
    			if(this.contacts[i]['id'] == this.data.companyUser[index]['user']['id']){
    			 	this.contacts[i]['isMember'] = true;
		 		}
	 		}
    	}
		if(res['hydra:view']['hydra:next']){
			this.loadContact(res['hydra:view']['hydra:next'].replace("/api", ""));
		}
    }); 
  }


  newContact(){
    if (this.showNewContactInput == true)  
      this.showNewContactInput = false;
    else
      this.showNewContactInput = true;
  }



   fctAddcontactByMail(){

      // Process checkout data here

       // stop here if form is invalid
      if (this.emailFormControl.status == 'INVALID') {
        return;
      }

      var result = this.emailFormControl.value;

      this.authService.addUserCompany(this.data.idcompany, result, true).subscribe(res => {
        this.searchContact = "";
        alert('Invitation envoyé'); 
        
        if(res['user'] && res['user']['id']){
          	var newUser = res;
          	this.data.companyUser.push(newUser);
        }

         //this.emailFormControl.value = null;
         this.emailInput.nativeElement.value = "";
      },
      (error) => {
       
        if(error.error && error.error.violations){
          alert(error.error.violations[0].message);
        }
        else
        {
          alert(error.statusText);
        }

      });

   }

   fctAddEmployeeByMail(){

    // Process checkout data here

     // stop here if form is invalid
    if (this.emailFormControl.status == 'INVALID') {
      return;
    }

    var result = this.emailFormControl.value;

    this.authService.addEmployeeCompany(result).subscribe(res => {
      alert('Invitation envoyé'); 
       //this.emailFormControl.value = null;
       this.emailInput.nativeElement.value = "";
       this.dialogRef.close();
    },
    (error) => {
      if (error.status === 403) {
        this.openPackComponentDialog(1);
      } else if (error.status === 402) {
        const errorDescription = JSON.parse(error.error['hydra:description']);
        this.openPackComponentDialog(2, errorDescription.subscriptionPack);
      } else if (error.status === 429) {
        this.openPackComponentDialog(3);
      } else if (error.status === 401) {
        const errorMessage = error.error["hydra:description"] || 'Une erreur est survenue.';
        alert(errorMessage);
      } else if(error.error && error.error.violations){
        alert(error.error.violations[0].message);
      }
      else
      {
        alert(error.statusText);
      }

    });

 }

 openPackComponentDialog(type = 0, currentPack = 'free'){
         const dialogRef = this.dialog.open(PackComponent, {
           panelClass: 'packclass',
           backdropClass: 'custom-backdrop-pack',
           height: "height: calc(-80px + 100vh);",
           data: { type: type, pack: currentPack}
         });
     
         dialogRef.afterClosed().subscribe(result => {
         });
  }


  fctAdMember(userInfo){
    if(this.addingMember){return false;}
	  this.addingMember = true;
    this.authService.addUserCompany(this.data.idcompany, userInfo.id, null).subscribe(
    	res => {
	        if(res){
	        	var newUser = res;
		        //this.userStatus[res['user']['id']] = res['status'];
		        this.data.companyUser.push(newUser);
		        for (var i = 0; i < this.contacts.length; i++) {
		    		for (let index = 0; index < this.data.companyUser.length; index++) {
		    			if(this.contacts[i]['id'] == this.data.companyUser[index]['user']['id']){
		    				this.contacts[i]['isMember'] = true;
				 		}
			 		}
		    	}
		        this.searchContact = "";
	        }
	       	this.addingMember = false;
	    },
	    (error) => {
	      this.addingMember = false;
	      if(error.error && error.error.violations){
	        alert(error.error.violations[0].message);
	      }
	      else
	      {
	        alert(error.statusText);
	      }
    	}
    );
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

